import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToBottom()

    this.observer = new MutationObserver(() => {
      if (this.nearBottom()) {
        this.scrollToBottom()
      }
    })

    this.observer.observe(this.element, {
      childList: true
    })
  }

  disconnect() {
    this.observer.disconnect()
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }

  nearBottom() {
    const threshold = 200 // px from bottom
    const { scrollTop, scrollHeight, clientHeight } = this.element

    return scrollHeight - scrollTop - clientHeight < threshold
  }
}
